import React from 'react';
import LoadingCircle from '../../assets/loading-circle';

const CenteredLoader = ({ className, ...props }) => (
  <div
    className={`CenteredLoader__root ${className || ''}`}
    {...props}
    style={{
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100px',
    }}
  >
    <LoadingCircle fill="#346cf7" />
  </div>
);

export default CenteredLoader;
